import { render, staticRenderFns } from "./bottomRight3.vue?vue&type=template&id=23c83c12&"
import script from "./bottomRight3.vue?vue&type=script&lang=js&"
export * from "./bottomRight3.vue?vue&type=script&lang=js&"
import style0 from "./bottomRight3.vue?vue&type=style&index=0&id=23c83c12&prod&lang=scss&class=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports